var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 14510"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7785 7.24776C14.0738 7.57826 14.0738 8.11402 13.7785 8.44436L8.70574 14.1207C8.41037 14.451 7.93172 14.451 7.63635 14.1207L5.22153 11.4184C4.92616 11.0881 4.92616 10.5523 5.22153 10.222C5.51675 9.89149 5.99555 9.89149 6.29078 10.222L8.17097 12.3258L12.7091 7.24776C13.0044 6.91741 13.4832 6.91741 13.7785 7.24776Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkayIcon);
export default __webpack_public_path__ + "static/media/okay-icon.87b7815263a676278e0fe8dcfbaeffa1.svg";
export { ForwardRef as ReactComponent };